<template>
  <Selector
    id="productCategory"
    name="productCategory"
    :label="$t('Choisissez votre contrat')"
    :modelValue="modelValue"
    :options="selectorOptions"
    @update:modelValue="$emit('update:modelValue', $event)"
  />
</template>

<script>
import { Selector } from "@estaly/ui";

export default {
  components: {
    Selector,
  },
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    categories: {
      type: Array,
      required: true,
    },
  },

  computed: {
    selectorOptions() {
      return this.categories.map((category) => ({
        value: category.value,
        label: this.$t(category.name),
      }));
    },
  },
};
</script>
